import {useOperation} from "../use-operation.hook"
import {ProductView} from "../interfaces/product-view.interface";

export default function useProducts() {
    return useOperation<ProductView[]>('getAllProducts')
}